export default __webpack_public_path__ + "static/media/mangaKeitt.411e07bf.jpg";